/* RESPONSIBLE TEAM: team-standalone */

import StandardOnboardingGuideStep from '../standard-onboarding-guide-step';

export default class GenericOnboardingGuideStep extends StandardOnboardingGuideStep {
  override get platformName() {
    return this.platform.platformKey;
  }

  override titleKey(stepIdentifier: string): string {
    if (this.platformIsDependent(stepIdentifier)) {
      return `onboarding.getting-started.steps.${stepIdentifier}.generic.title`;
    }
    return `onboarding.getting-started.steps.${stepIdentifier}.title`;
  }

  override descriptionKey(stepIdentifier: string): string {
    if (stepIdentifier === 'fin_sa_onboarding_add_support_content') {
      return `onboarding.getting-started.steps.${stepIdentifier}.generic.generic-description`;
    }
    if (this.platformIsDependent(stepIdentifier)) {
      return `onboarding.getting-started.steps.${stepIdentifier}.generic.description`;
    }
    return `onboarding.getting-started.steps.${stepIdentifier}.description`;
  }

  override ctaKey(stepIdentifier: string): string {
    if (this.platformIsDependent(stepIdentifier)) {
      return `onboarding.getting-started.steps.${stepIdentifier}.generic.cta`;
    }
    return `onboarding.getting-started.steps.${stepIdentifier}.cta`;
  }
}
